/**
 * Recursive context-menu DOM renderer, extracted from Chart.tsx. Self-
 * contained apart from a closeMenu callback (the row click runs the action
 * then closes the menu). Verbatim body; setContextMenu(null) -> closeMenu().
 */
import type { ReactNode } from "react";
import { MenuGlyph } from "./menuGlyphs";
import type { MenuItem } from "./types";
import styles from "./Chart.module.css";

export function renderMenuItems(
  items: MenuItem[],
  closeMenu: () => void,
): ReactNode {
  return items.map((item, i) => {
    if (item.separator) {
      return <div key={i} className={styles.menuDivider} />;
    }
    if (item.children) {
      return (
        <div key={i} className={styles.submenuWrap}>
          <button
            type="button"
            className={`${styles.contextMenuItem} ${styles.hasSub}`}
          >
            <span className={styles.menuIcon}>
              {item.icon ? <MenuGlyph name={item.icon} /> : null}
            </span>
            <span className={styles.menuText}>{item.label}</span>
            <span className={styles.caret}>›</span>
          </button>
          <div className={styles.submenu}>
            {renderMenuItems(item.children, closeMenu)}
          </div>
        </div>
      );
    }
    // A leading "✓ " marks a checked toggle; show it as a trailing
    // check so the leading icon column stays aligned.
    const checked = item.label.startsWith("✓ ");
    const text = checked ? item.label.slice(2) : item.label;
    return (
      <button
        key={i}
        type="button"
        disabled={item.disabled}
        className={`${styles.contextMenuItem} ${item.danger ? styles.contextMenuDanger : ""}`}
        onClick={() => {
          if (item.disabled) return;
          item.action?.();
          closeMenu();
        }}
      >
        <span className={styles.menuIcon}>
          {item.icon ? <MenuGlyph name={item.icon} /> : null}
        </span>
        <span className={styles.menuText}>{text}</span>
        {checked ? <span className={styles.menuTick}>✓</span> : null}
      </button>
    );
  });
}
